<template>
  <form class="row" @submit.prevent="onSubmit">
    <div class="box-bullets">
      <div class="bullet-diver">&nbsp;</div>
      <ul class="bullets">
        <li class="bullet-item" @click="btnNextStep(1)"><span class="bullet" :class="{ active: stepSelected === 1, completed: isCompletedStep1 }">1</span></li>
        <li class="bullet-item" @click="btnNextStep(2)"><span class="bullet" :class="{ active: stepSelected === 2, completed: isCompletedStep2 }">2</span></li>
        <li class="bullet-item" @click="btnNextStep(3)"><span class="bullet" :class="{ active: stepSelected === 3, completed: isCompletedStep3 }">3</span></li>
      </ul>
    </div>

    <div class="medium-12 columns" v-if="stepSelected === 1">
      <label :class="{ error: $v.name.$error }">
        {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_NAME') }}
        <input
          v-model.trim="name"
          type="text"
          :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_NAME')"
          @input="$v.name.$touch"
        />
        <span v-if="$v.name.$error" class="message">
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_NAME') }}
        </span>
      </label>

      <label :class="{ error: $v.description.$error }">
        {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_DESCRIPTION') }}
        <input
          v-model.trim="description"
          type="text"
          :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_DESCRIPTION')"
          @input="$v.description.$touch"
        />
        <span v-if="$v.description.$error" class="message">
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_DESCRIPTION') }}
        </span>
      </label>

      <label :class="{ error: $v.selectedSchedule.$error }">
        {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_RULE_CRON') }}
        <multiselect
          v-model="selectedSchedule"
          track-by="id"
          label="name"
          :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_RULE_CRON')"
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          :max-height="160"
          :options="scheduleOptions"
          @input="$v.selectedSchedule.$touch"
        />
        <span v-if="$v.selectedSchedule.$error" class="message">
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_RULE_CRON') }}
        </span>
      </label>
    </div>

    <div class="medium-12 columns" v-if="stepSelected === 2">
      <div class="row">
        <div class="medium-6 columns">
          <label :class="{ error: $v.host.$error }">
            {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_HOST') }}
            <input
              v-model.trim="host"
              type="text"
              :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_HOST')"
              @input="$v.host.$touch"
            />
            <span v-if="$v.host.$error" class="message">
              {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_HOST') }}
            </span>
          </label>
        </div>

        <div class="medium-6 columns">
          <label :class="{ error: $v.port.$error }">
            {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_PORT') }}
            <input
              v-model.trim="port"
              type="number"
              min="1"
              max="65535"
              :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_PORT')"
              @input="$v.port.$touch"
            />
            <span v-if="$v.port.$error" class="message">
              {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_PORT') }}
            </span>
          </label>
        </div>

        <div class="medium-6 columns">
          <label :class="{ error: $v.database_name.$error }">
            {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_DATABASE') }}
            <input
              v-model.trim="database_name"
              type="text"
              :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_DATABASE')"
              @input="$v.database_name.$touch"
            />
            <span v-if="$v.database_name.$error" class="message">
              {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_DATABASE') }}
            </span>
          </label>
        </div>

        <div class="medium-6 columns">
          <label :class="{ error: $v.username.$error }">
            {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_USERNAME') }}
            <input
              v-model.trim="username"
              type="text"
              :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_USERNAME')"
              @input="$v.username.$touch"
            />
            <span v-if="$v.username.$error" class="message">
              {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_USERNAME') }}
            </span>
          </label>
        </div>
      </div>

      <label :class="{ error: $v.password.$error }">
        {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_PASSWORD') }}
        <input
          v-model.trim="password"
          type="password"
          :placeholder="passwordPlaceholder"
          @input="$v.password.$touch"
        />
        <small v-if="isEditing" class="help-text">
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.HELP_PASSWORD') }}
        </small>
        <span v-if="$v.password.$error" class="message">
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_PASSWORD') }}
        </span>
      </label>
    </div>

    <div class="medium-12 columns" v-if="stepSelected === 3">
      <label :class="{ error: $v.typebot.$error }">
        {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_TYPEBOT') }}
        <input
          v-model.trim="typebot"
          type="text"
          name="typebot"
          :placeholder="$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_TYPEBOT')"
          @input="$v.typebot.$touch"
        />
        <span v-if="$v.typebot.$error" class="message">
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.ERROR_TYPEBOT') }}
        </span>
      </label>

      <label>
        {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.DESC_TYPEBOT') }}
        <img
          src="/assets/images/dashboard/cadencia/typebot.png"
          :alt="$t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_TYPEBOT')"
        />
      </label>

      <label>{{ $t('INTEGRATION_SETTINGS.SYONET.FORM.LABEL_ACTIVE') }}</label>
      <woot-switch
        :value="active"
        @input="value => (active = value)"
      />
    </div>


    <div class="modal-footer footer-actions">
      <div class="medium-12 columns box-actions">
        <woot-button
          class="button clear"
          @click.prevent="btnPreviousStep"
          v-if="stepSelected > 1"
        >
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.BTN_PREV') }}
        </woot-button>
        <woot-button
          class="button clear"
          @click.prevent="$emit('cancel')"
          v-else
        >
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.BTN_CLOSE') }}
        </woot-button>

        <woot-button
          class="button clear"
          :is-loading="isTestingConnection"
          :disabled="isSubmitting || isTestingConnection || stepSelected === 1"
          @click.prevent="onTestConnection"
        >
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.BTN_TEST') }}
        </woot-button>

        <woot-button
          @click.prevent="btnNextStep(null)"
          v-if="showBtnNextStep"
        >
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.BTN_NEXT') }}
        </woot-button>
        <woot-button
          :disabled="isValid || isSubmitting"
          :is-loading="isSubmitting"
          v-else
        >
          {{ $t('INTEGRATION_SETTINGS.SYONET.FORM.BTN_SUBMIT') }}
        </woot-button>
      </div>
    </div>
  </form>
</template>

<script>
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';
import { SYONET_SCHEDULE_OPTIONS } from './scheduleOptions';

const validPort = value => {
  const numericValue = Number(value);
  return numericValue > 0 && numericValue <= 65535;
};

const requiredWhenCreating = function(value) {
  if (this.isEditing) {
    return true;
  }

  return required(value);
};

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    isTestingConnection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepSelected: 1,
      scheduleOptions: SYONET_SCHEDULE_OPTIONS,
      name: this.value.name || '',
      description: this.value.description || '',
      host: this.value.host || '',
      port: this.value.port || 5432,
      database_name: this.value.database_name || '',
      username: this.value.username || '',
      typebot: this.value.typebot || '',
      password: '',
      selectedSchedule:
        SYONET_SCHEDULE_OPTIONS.find(option => option.id === this.value.rule_cron) ||
        SYONET_SCHEDULE_OPTIONS[0],
      active: this.value.active !== false,
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(255),
    },
    description: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(255),
    },
    host: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(255),
    },
    port: {
      required,
      numeric,
      validPort,
    },
    database_name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(255),
    },
    username: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(255),
    },
    password: {
      required: requiredWhenCreating,
      minLength: value => !value || minLength(3)(value),
    },
    selectedSchedule: {
      required,
    },
    typebot: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(255),
    },
  },
  computed: {
    showBtnNextStep() {
      return this.stepSelected < 3;
    },
    isCompletedStep1() {
      return this.name && this.description && this.selectedSchedule && this.stepSelected > 1;
    },
    isCompletedStep2() {
      return this.isCompletedStep1 && this.host && this.database_name && this.username && this.port && this.stepSelected > 2;
    },
    isCompletedStep3() {
      return this.isCompletedStep2 && this.typebot;
    },
    isValid() {
      return this.$v.$invalid;
    },
    isEditing() {
      return !!this.value.id;
    },
    rule_cron() {
      return this.selectedSchedule?.id || '';
    },
    passwordPlaceholder() {
      if (this.isEditing) {
        return this.$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_PASSWORD_KEEP');
      }

      return this.$t('INTEGRATION_SETTINGS.SYONET.FORM.PLACEHOLDER_PASSWORD');
    },
  },
  methods: {
    btnPreviousStep() {
      if (this.stepSelected === 1) {
        this.$emit('cancel');
      } else {
        this.stepSelected -= 1;
      }
    },
    btnNextStep(step = null) {
      if (this.stepSelected === 1) {
        this.$v.name.$touch();
        this.$v.description.$touch();
        this.$v.selectedSchedule.$touch();

        if (this.$v.name.$invalid || this.$v.description.$invalid || this.$v.selectedSchedule.$invalid) {
          return;
        }
      }

      if (this.stepSelected === 2) {
        this.$v.host.$touch();
        this.$v.port.$touch();
        this.$v.database_name.$touch();
        this.$v.username.$touch();
        this.$v.password.$touch();

        if (
          this.$v.host.$invalid ||
          this.$v.port.$invalid ||
          this.$v.database_name.$invalid ||
          this.$v.username.$invalid ||
          this.$v.password.$invalid
        ) {
          return;
        }
      }

      if (step) {
        this.stepSelected = step;
      } else {
        this.stepSelected += 1;
      }
    },
    buildConnectionPayload() {
      const syonetConnection = {
        name: this.name,
        description: this.description,
        host: this.host,
        port: Number(this.port),
        database_name: this.database_name,
        username: this.username,
        typebot: this.typebot,
        rule_cron: this.rule_cron,
        active: this.active,
      };

      if (this.password) {
        syonetConnection.password = this.password;
      }

      return syonetConnection;
    },
    onTestConnection() {
      if (this.stepSelected === 1) {
        return;
      }

      this.$v.host.$touch();
      this.$v.port.$touch();
      this.$v.database_name.$touch();
      this.$v.username.$touch();
      this.$v.password.$touch();

      if (
        this.$v.host.$invalid ||
        this.$v.port.$invalid ||
        this.$v.database_name.$invalid ||
        this.$v.username.$invalid ||
        this.$v.password.$invalid
      ) {
        return;
      }

      this.$emit('test-connection', this.buildConnectionPayload());
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('submit', this.buildConnectionPayload());
    },
  },
};
</script>

<style scoped lang="scss">
.help-text {
  display: block;
  margin-top: var(--space-smaller);
}

.box-bullets {
  width: 100%;
  margin: 0 10% 20px;
  position: relative;
  .bullets {
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    .bullet-item {
      z-index: 1;
      cursor: pointer;
      .bullet {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #1b387c;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #1b387c;
        &.active {
          background: #1b387c;
          color: #fff;
        }
        &.completed {
          background: #27ae60;
          border: 1px solid #27ae60;
          color: #fff;
        }
      }
    }
  }
  .bullet-diver {
    width: 100%;
    height: 1px;
    background: #1b387c;
    margin-top: 17px;
    position: absolute;
    top: 0;
  }
}

.footer-actions {
  width: 100%;
  .box-actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
